import { Cloud, Stars } from "@react-three/drei"

export const Clouds = () => {
    
    return(
        <group position={[0,-8,0]}>
            <Cloud
                position-x={14}
                opacity={0.4}
                speed={0.4}
                width={3}
                depth={5}
                segments={5}
            />
            <Stars position={[0,0,0]} radius={50} depth={50} count={1000} factor={5} saturation={0} fade speed={1} />
            <Cloud
                position-x={-14}
                opacity={0.4}
                speed={0.4}
                width={5}
                depth={5}
                segments={4}
            />
        </group>
    )
}
